import React from "react";
import { PlusOutlined, PlusCircleOutlined, DeleteFilled, HolderOutlined, DragOutlined } from "@ant-design/icons";
import { Utils } from "@react-awesome-query-builder/ui";
var DragIcon = Utils.DragIcon;
var typeToIcon = {
  "addRule": /*#__PURE__*/React.createElement(PlusOutlined, null),
  "addGroup": /*#__PURE__*/React.createElement(PlusCircleOutlined, null),
  "delRule": /*#__PURE__*/React.createElement(DeleteFilled, null),
  "delGroup": /*#__PURE__*/React.createElement(DeleteFilled, null),
  "delRuleGroup": /*#__PURE__*/React.createElement(DeleteFilled, null),
  "addSubRuleSimple": /*#__PURE__*/React.createElement(PlusOutlined, null),
  "addSubRule": /*#__PURE__*/React.createElement(PlusOutlined, null),
  "addSubGroup": /*#__PURE__*/React.createElement(PlusCircleOutlined, null),
  "drag": HolderOutlined ? /*#__PURE__*/React.createElement(HolderOutlined, null) : /*#__PURE__*/React.createElement(DragOutlined, null) // Compatible with @ant-design/icons@4.x
};
export default (function (_ref) {
  var type = _ref.type;
  var icon = typeToIcon[type] || null;
  if (!icon && type === "drag") {
    icon = /*#__PURE__*/React.createElement(DragIcon, null);
  }
  return icon;
});